function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocShopRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 27h-4v-4c0-1.103.897-2 2-2s2 .897 2 2v4zm-2-8a4 4 0 00-4 4v6h8v-6a4 4 0 00-4-4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 15c-1.104 0-2-.897-2-2h-2c0 1.103-.896 2-2 2s-2-.897-2-2h-2c0 1.103-.896 2-2 2s-2-.897-2-2H9c0 1.103-.896 2-2 2-1.048 0-1.91-.81-1.993-1.836L7.693 6h16.614l2.686 7.164A2.002 2.002 0 0125 15zm.693-11H6.307L3 12.819V13c0 1.858 1.279 3.411 3 3.858V27a2 2 0 002 2h2v-2H8V16.86a4.001 4.001 0 002-1.217A3.99 3.99 0 0013 17a3.99 3.99 0 003-1.357A3.99 3.99 0 0019 17a3.99 3.99 0 003-1.357 4.001 4.001 0 002 1.217V27h-2v2h2a2 2 0 002-2V16.858c1.721-.447 3-2 3-3.858v-.181L25.693 4z",
    fill: props.color
  }));
}

export default SvgIconPocShopRexOutline;